"use client";

import { Card } from "@/app/pwa/components/Card";;
import Image from "@/app/pwa/components/Image";
import Slider from "react-slick";
import "@/css/_react-slick.css";
import Feature1 from "@/assets/dummy/claim/feature-01.webp";
import Feature2 from "@/assets/dummy/claim/feature-02.webp";
import Feature3 from "@/assets/dummy/claim/feature-03.webp";

// import FeatureA1 from "@/assets/inquiry/Umfrage.png";
// import FeatureA2 from "@/assets/inquiry/TrainingBearbeitung.png";
// import FeatureA3 from "@/assets/inquiry/Training.png";
// import FeatureA4 from "@/assets/inquiry/Einladung.png";

import FeatureA1 from "@/assets/mockup/square/abstimmung.webp";
import FeatureA2 from "@/assets/mockup/square/termine.webp";
import FeatureA3 from "@/assets/mockup/square/teilnahme.webp";
import FeatureA4 from "@/assets/mockup/square/einladung.webp";

export function InquirySlider() {
  // TODO: Content
  return (
    <Card p={false}>
      <Slider
        slidesToShow={1}
        slidesToScroll={1}
        dots
        infinite
        speed={500}
        arrows={false}
      >
        <div>
          <h2 className="pt-2 text-lg font-semibold inline-flex w-full justify-center text-gray-900">
            Abstimmungen leicht gemacht
          </h2>
          <p className="px-2 pb-2 text-center">
            Entscheide gemeinsam über wichtige Fragen.
          </p>
          <Image alt="Image" src={FeatureA1.src} className="w-full block aspect-[4/3] object-cover object-top" width="1414" height="1414" />
        </div>
        <div className="">
          <h2 className="pt-2 text-lg font-semibold inline-flex w-full justify-center text-gray-900">
            Alle Termine im Blick
          </h2>
          <p className="px-2 pb-2 text-center">
            Plane alle Vereinsaktivitäten an einem Ort.
          </p>
          <Image alt="Image" src={FeatureA2.src} className="w-full block aspect-[4/3] object-cover object-top" width="1414" height="1414" />
        </div>
        <div className="">
          <h2 className="pt-2 text-lg font-semibold inline-flex w-full justify-center text-gray-900">
            Teilnahmen abfragen
          </h2>
          <p className="px-2 pb-2 text-center">
            Sei immer informiert, wer teilnimmt.
          </p>
          <Image alt="Image" src={FeatureA3.src} className="w-full block aspect-[4/3] object-cover object-top" width="1414" height="1414" />
        </div>
        <div className="">
          <h2 className="pt-2 text-lg font-semibold inline-flex w-full justify-center text-gray-900">
            Vereinsmitglieder einladen
          </h2>
          <p className="px-2 pb-2 text-center">
            Einladen und gemeinsam organisieren.
          </p>
          <Image alt="Image" src={FeatureA4.src} className="w-full block aspect-[4/3] object-cover object-top" width="1414" height="1414" />
        </div>
      </Slider>
    </Card>
  );
}
